export default __webpack_public_path__ + "imgs/toForever03.793b7f8.jpeg";